'use client';

import { useEffect } from 'react';

type LandingSkillsPreviewDebugLoggerProps = {
  logId: string;
  response: unknown;
};

export function LandingSkillsPreviewDebugLogger({
  logId,
  response,
}: LandingSkillsPreviewDebugLoggerProps) {
  useEffect(() => {
    console.log('[agentic-hub] browser landing demo response', response);
    console.log('[agentic-hub] browser landing demo x-tt-logid', logId);
  }, [logId, response]);

  return null;
}
